<template>
  <span class="selected-filters">
    <span v-if="hasSelected" class="selected-filters__reset">
      <BaseButton
        theme="error"
        size="extra-small"
        outline
        min-width="auto"
        @click="emit('handle-clear')"
      >{{ $t('catalog.filters.clear_all') }}</BaseButton>
    </span>

    <span
      v-for="filter in selectedFilterQuery"
      :key="`${filter.code}_${filter.value}`"
      class="selected-filters__item"
    >{{
      filter.label === 'True'
        ? $t('common.yes')
        : filter.label === 'False'
          ? $t('common.no')
          : filter.label
    }}<span
      class="selected-filters__item-close icon-times-light"
      @click="emit('delete-filter', filter)"
    />
    </span>
  </span>
</template>

<script lang="ts" setup>
import type { SelectedFilter } from '~/types/catalog'

type Props = {
  selectedFilterQuery: SelectedFilter[]
  showClearButton?: boolean
}

type Emits = {
  (eventName: 'handle-clear'): void
  (eventName: 'delete-filter', value: SelectedFilter): void
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const hasSelected = computed(() => {
  return props.showClearButton && props.selectedFilterQuery.length
})
</script>

<style lang="scss">
.selected-filters {
  &__reset {
    float: left;
    margin-right: 0.8rem;
  }

  &__item {
    background-color: #f3f3f3;
    box-sizing: border-box;
    border-radius: 4px;
    font-size: 1.2rem;
    line-height: 1.8rem;
    padding: 0.3rem 0.8rem;
    display: inline-flex;
    align-items: center;
    height: 2.4rem;
    max-width: 100%;
    animation: opacity-selected $transition-time;
    margin-right: 0.8rem;
    margin-bottom: 0.8rem;

    &-value {
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    &-close {
      margin-left: 0.8rem;
      opacity: 0.5;
      cursor: pointer;
    }
  }
}

@keyframes opacity-selected {
  from {
    opacity: 0.5;
  }
  to {
    opacity: 1;
  }
}
</style>
